import Axios from "./AxiosInterceptorsService";
import { flattenObjectForUrlParams, isComplexObject } from "../utils/RequestUtils";

export const requestService = {
    post: async (url: string, data: any, params: Record<string, any> = {}) => {
        try {
            return await Axios.post(url, data, params);
        } catch (e: any) {
            throw e;
        }
    },
    get: async (url: string, data: any = {}, header: any = {}, config: any = {}) => {
        try {
            let headers = {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...header
            };

            // Automatically flatten complex objects for URL parameters
            let params = data;
            if (isComplexObject(data)) {
                params = flattenObjectForUrlParams(data);
            }

            // config spreads extra Axios options (e.g. responseType: 'blob' for file downloads) so
            // domain APIs never reach for the interceptor directly.
            return await Axios.get(url, {
                signal: data.signal,
                params: params,
                headers: headers,
                ...config,
            });
        } catch (e: any) {
            throw e;
        }
    },
    put: async (url: string, data: any, config = {} as any) => {
        try {
            return await Axios.put(url, data, config);
        } catch (e: any) {
            throw e;
        }
    },
    patch: async (url: string, data: any, config = {} as any) => {
        try {
            return await Axios.patch(url, data, config);
        } catch (e: any) {
            throw e;
        }
    },
    del: async (url: string, data: any = {}) => {
        try {
            return await Axios.delete(url, data);
        } catch (e: any) {
            throw e;
        }
    }
};